import { render, staticRenderFns } from "./TagDialog.vue?vue&type=template&id=600715a6&"
import script from "./TagDialog.vue?vue&type=script&lang=ts&"
export * from "./TagDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600715a6')) {
      api.createRecord('600715a6', component.options)
    } else {
      api.reload('600715a6', component.options)
    }
    module.hot.accept("./TagDialog.vue?vue&type=template&id=600715a6&", function () {
      api.rerender('600715a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tags/TagDialog.vue"
export default component.exports